import ReactDOM from "react-dom";

import React, { useEffect, useState, useRef } from "react";
import "./SignatureModal.scss";
import SignatureCanvas from "react-signature-canvas";
import axiosInstance from "../api/axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import { singFile } from "../actions/authActions";
import { rootReducer } from "../store/store";
import { Driver } from "../types/DriverTypes";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SvgIcon from "@mui/material/SvgIcon";
type AuthState = ReturnType<typeof rootReducer>;
interface signProps {
  isOpen: boolean;
  onClose: () => void;
  target?: string;
  driverNum: number;
  setSignImg?: React.Dispatch<React.SetStateAction<string>> | any;
  driverListProp?: Array<Driver> | any;
  setDriverListProp?: React.Dispatch<React.SetStateAction<string>> | any;
}

const Signaturesign: React.FC<signProps> = ({
  isOpen,
  onClose,
  target,
  driverNum,
  driverListProp,
}) => {
  const [isSigned, setIsSigned] = useState<boolean>(false);
  const signatureCanvasRef = useRef<any>();
  const handleResetSignature = () => {
    signatureCanvasRef.current.clear(); // 서명 캔버스 리셋
    // driverListProp[driverNum - 1].singImg = "";
    // if (driverNum === 1) {
    // } else {
    // }
  };

  if (!isOpen) return null;

  const handleSaveSignature = async () => {
    if (!signatureCanvasRef.current.isEmpty()) {
      const signatureImageURL = signatureCanvasRef.current.toDataURL();
      driverListProp[driverNum - 1].singImg = signatureImageURL;
      signatureCanvasRef.current.clear();
      onClose();

      // 데이터 URL을 Base64 인코딩된 문자열로 변환 (백엔드에서 처리 중...)
      // const encodedImage = signatureImageURL.split(",")[1];

      // if (driverNum === 0) {
      //   dispatch(singFile(signatureImageURL));
      // } else {
      //   dispatch(singFile(signatureImageURL));
      // }

      // await axiosInstance()
      //   .post("/kiosk/ajaxSaveSignatureImage.do", {
      //     companyId: data?.companyId,
      //     reservationId: data?.reservationId,
      //     target: target,
      //     signNature: signatureImageURL,
      //     // driverType: driverNum,
      //   })
      //   .then((res) => {
      //     if (res.data.result === "success") {
      //       onClose();
      //     }
      //   });
    }
  };

  return ReactDOM.createPortal(
    <>
      {/* <img src={signImage}></img> */}
      <div className="sign-overlay" />
      <div className="sign-container">
        <div className="sign-content">
          <div className="sign-header">
            <div
              style={{
                width: "100%",
                fontWeight: "700",
                fontSize: "2em",
                textAlign: "center",
                borderBottom: "2px solid #e4e7ec",
                lineHeight: 2.5,
              }}
            >
              계약서에 서명해주세요.
            </div>
            <SvgIcon
              component={CloseOutlinedIcon}
              style={{
                position: "absolute",
                fontSize: "3em",
                right: "3%",
                top: "40px",
              }}
              onClick={() => {onClose(); setIsSigned(false)}}
            ></SvgIcon>
          </div>
          <div style={{
            color: '#ee0000',
            fontWeight: '600',
            fontSize: '1.5em',
            marginLeft: '10px'
          }}>
            !서명은 정자로 해주세요.
          </div>
          <div className='sign-placeholder-wrap'>
          {driverListProp[driverNum - 1]?.driverName || ''}
          </div>
          <div className="sign-sign">
            <SignatureCanvas
              canvasProps={{ className: "canvasStyle" }}
              ref={signatureCanvasRef}
              onBegin={() => {setIsSigned(true)}}
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="reset-btn-wrap">
            <button className="reset-btn" onClick={handleResetSignature}>
              초기화{" "}
              <SvgIcon
                component={RefreshOutlinedIcon}
                color="disabled"
                style={{
                  fontSize: "1.5em",
                  color: "white",
                  marginLeft: "5px",
                }}
              ></SvgIcon>
            </button>
          </div>
          <div className="next-btn-wrap">
            <button className="next-btn" onClick={handleSaveSignature}>
              등록
            </button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("sign-root") as HTMLElement
  );
};

export default Signaturesign;
